export const TitleComponent = ({ title }) => (
    <div className="text-center text-2xl sm:text-3xl mb-8">{title}</div>
  );